import { Component, EventEmitter, OnDestroy, Optional, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslatePipe } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { SapSubmittalService } from '../../../../../services/sap-submittal.service';

@Component({
  selector: 'app-sap-submittal-request-dialog',
  imports: [
    MatIcon,
    TranslatePipe,
    MatButtonModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './sap-submittal-request-dialog.component.html',
  styleUrl: './sap-submittal-request-dialog.component.scss'
})
export class SapSubmittalRequestDialogComponent implements OnDestroy {

  /** Subject for subscription cleanup */
  private readonly destroy$ = new Subject<void>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  constructor(
    @Optional() private dialogRef: MatDialogRef<SapSubmittalRequestDialogComponent>,
    private readonly sapSubmittalService: SapSubmittalService
  ) {
  }

  /**
   * Triggered when user clicks OK to proceed with SAP submission.
   * Delegates the entire orchestration flow to the service.
   */
  requestSapSubmission(): void {
    this.sapSubmittalService.executeFullSubmittalFlow(() => this.dialogRef?.close());
  }

  onCancel() {
    this.cancel.emit();
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
